import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation pt-5 pb-3 py-md-5" }
const _hoisted_2 = { class: "container navigation__items" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Studio C Company ")
const _hoisted_4 = { class: "navigation__items-links mt-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Brands")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Contact")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navigation__items-logo"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/brands" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ])
  ]))
}